import React from "react";
import { Link } from "react-router-dom";

const JournyCard = ({title, img,link}) => {
  return (
    <Link
      to={`/inspiration/${link}`}
      className="journey-container"
    >
      <img
        alt="Style icon"
        loading="lazy"
        width="46"
        height="62"
        src={img}
      />
      <div>{title}</div>
    </Link>
  );
};

export default JournyCard;
